import { PencilIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";

export default function CreateNoteStep({ onCreateNote, onSkip, onBack, showBack }) {
  return (
    <div className="flex flex-col items-center text-center">
      {/* Back button */}
      {showBack && (
        <button
          onClick={onBack}
          className="self-start -mt-2 mb-2 p-1 rounded-md text-white/60 hover:text-white/80"
          aria-label="Go back"
        >
          <ArrowLeftIcon className="h-5 w-5" />
        </button>
      )}

      <h2 className="text-2xl font-bold text-white mb-2">
        Leave Your First Trace
      </h2>
      <p className="text-white/70 text-sm mb-8 max-w-xs">
        Notes are messages tied to your current location. People nearby can
        discover and interact with them.
      </p>

      {/* Icon — circular to match the actual create note button */}
      <div className="h-20 w-20 rounded-full bg-white/30 border border-white/40 grid place-items-center mb-3 shadow-lg">
        <PencilIcon className="h-10 w-10 text-primary" />
      </div>

      <p className="text-white/50 text-xs mb-8">
        Tap this button on the map to create a note anytime
      </p>

      {/* Actions */}
      <div className="flex items-center gap-4 w-full">
        <button
          onClick={onSkip}
          className="flex-1 py-2.5 text-sm text-white/60 hover:text-white/80"
        >
          Skip
        </button>
        <button
          onClick={onCreateNote}
          className="flex-1 py-2.5 rounded-lg bg-primary hover:bg-primary-hover text-text-inverse text-sm font-medium"
        >
          Create a Note
        </button>
      </div>
    </div>
  );
}
